/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeV2TopMenuBarProps } from './moe-v2-top-menu-bar.props.autogenerated';

export interface IMoeV2TopMenuBarViewProps extends IMoeV2TopMenuBarProps<{}> {
    currentPath?: string;
    mobileOpen?: boolean;
    setMobileOpen?: (open: boolean) => void;
}

interface IMoeV2TopMenuBarState {
    mobileOpen: boolean;
}

/**
 * MoeV2TopMenuBar component
 */
class MoeV2TopMenuBar extends React.PureComponent<IMoeV2TopMenuBarProps<{}>, IMoeV2TopMenuBarState> {
    constructor(props: IMoeV2TopMenuBarProps<{}>) {
        super(props);
        this.state = { mobileOpen: false };
        this.setMobileOpen = this.setMobileOpen.bind(this);
    }

    public setMobileOpen = (open: boolean): void => {
        this.setState({ mobileOpen: open });
    };

    private getCurrentPath = (): string => {
        if (typeof window === 'undefined') {
            return '';
        }

        try {
            return window.location.pathname;
        } catch (error) {
            console.warn('Unable to get current path:', error);
            return '';
        }
    };

    public render(): JSX.Element | null {
        const currentPath = this.getCurrentPath();

        return this.props.renderView({
            ...this.props,
            currentPath,
            mobileOpen: this.state.mobileOpen,
            setMobileOpen: this.setMobileOpen,
            // Force re-render key to ensure component updates properly
            key: `menu-${this.props.config?.menuItems?.length || 0}`
        });
    }
}

export default MoeV2TopMenuBar;
